import {animateInViewport} from '@/transition'

$('.posts-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: false,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  })
})

$('.products-hero-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    grabCursor: false,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: true,
    on: {
      slideChangeTransitionEnd: function () {
        animateInViewport()
      },
    },
  })

  $container.find('.carousel-buttons a').on('click', function (e) {
    e.preventDefault()

    const $buttons = $container.find('.carousel-buttons a')
    const $clicked = $(this)
    const index = Number($clicked.data('slide-index'))
    const $materialsBlock = $('.block-materialsBlock').closest('.block-container')

    if (Number.isNaN(index)) return

    $buttons.removeClass('active-menu-item').addClass('inverted-link')
    $clicked.addClass('active-menu-item').removeClass('inverted-link')

    if ($clicked.data('slide-id') === 'materials') {
      $materialsBlock.stop(true, true).slideUp(200, function () {
        animateInViewport()
      })
    } else {
      $materialsBlock.stop(true, true).slideDown(200, function () {
        animateInViewport()
      })
    }

    if (swiper.params.loop) {
      swiper.slideToLoop(index)
    } else {
      swiper.slideTo(index)
    }
  })
})

$('.image-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    slidesPerView: 1,
    spaceBetween: 15,
    autoHeight: true,
  })
})
